import React, { Component } from "react";
import { connect } from "react-redux";
import User from "../components/User";
import { Redirect } from "react-router-dom";

class UserRoute extends Component {

    render() {
        const { user, loggedIn } = this.props;
        const landlord = user && user.isLandlord;
        if ( !loggedIn )
            return <Redirect to="/"/>;
        return (
            <User user={user} landlord={landlord} tenant={!landlord}/>
        );
    }

}

function mapStateToProps( state, ownProps ) {
    return {
        loggedIn: state.user.bearerToken ? true : false,
        user: state.user.data
    }
}

function mapDispatchToProps( dispatch, ownProps ) {
    return {

    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)( UserRoute );